import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import Popover  from 'vue-js-popover'
import axios from "axios"
import VueHead from 'vue-head'
import VueAxiosPlugin from "./plugins/vue-axios"
import VueShowPasswordInput from "./plugins/vue-show-password"
import VueAnalytics from 'vue-analytics'
import "loaders.css"
import { library } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { faCheck,faMobileAlt,faEye,faEyeSlash,faCheckDouble,faInfoCircle,faPlus,faMinus,faChevronDown,faChevronUp,faSearch,faShoppingCart,faSort,faSortUp,faSortDown,faStarHalfAlt,faStar,faDatabase,faUser,faQuestionCircle,faScroll,faCreditCard,faList, faUserCheck,faCartArrowDown,faPrint,faDownload } from "@fortawesome/free-solid-svg-icons"
import { faBuilding, faStar as farStar } from "@fortawesome/free-regular-svg-icons"

import { careerl,careers,careerls,careerss,career_back,postmba } from "@/const.js"

library.add(faCheck,faMobileAlt,faEye,faEyeSlash,faCheckDouble,faInfoCircle,faPlus,faMinus,faChevronDown,faChevronUp,faSearch,faBuilding,faShoppingCart,faSort,faSortUp,faSortDown,faStar,faStarHalfAlt,farStar,faDatabase,faUser,faQuestionCircle,faScroll,faCreditCard,faList,faUserCheck,faCartArrowDown,faPrint,faDownload);

Vue.use(Vuex)
Vue.use(Popover)
Vue.use(VueAxiosPlugin, { axios: axios })
Vue.use(VueShowPasswordInput)
Vue.use(VueHead)

Vue.use(VueAnalytics, {
  id: 'UA-153678542-1',
  router
})

Vue.component('v-select', vSelect)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false;
Vue.config.devtools = false;

const store = new Vuex.Store({
  state: {
    auth: {
      loggedin:c_loggedin,
      role:c_role,
      id:c_id,
      email:c_email
    },
    listitems:c_listitems,
    amount:0,
    careerl:careerl,
    careers:careers,
    careerl_select:careerls,
    careers_select:careerss,
    postmba:postmba,
    career_back:career_back,
    stripe_pk:stripe_pk,
  },
  mutations: {
    auth (state, auth) {
      state.auth.loggedin = auth.loggedin;
      state.auth.role = auth.role;
      state.auth.id = auth.id;
      state.auth.email = auth.email;
      state.listitems = auth.listitems;
    },
    wishitem (state, data){
      if(data.target=="append")
        state.listitems.wish.push(data.item_id);
      else if (data.target=="delete")
        state.listitems.wish.splice(state.listitems.wish.indexOf(data.item_id),1);
      if(state.auth.loggedin && state.auth.role=="user")
        axios.post("/api/wishlist", data)

    },
    addCart (state, item_id){
      if (state.listitems.cart.indexOf(item_id)<0)
        state.listitems.cart.push(item_id);
      if(state.auth.loggedin && state.auth.role=="user")
        axios.post("/api/cartlist", {cart:state.listitems.cart});
    },
    paySuccess (state){
      state.listitems.own = state.listitems.own.concat(state.listitems.cart);
      state.listitems.cart = [];
      axios.post("/api/cartlist", {cart:state.listitems.cart});
    },
    removeCart (state, item_id){
      let index = state.listitems.cart.indexOf(item_id);
      if (index > -1)
        state.listitems.cart.splice(index, 1);
      if(state.auth.loggedin && state.auth.role=="user")
        axios.post("/api/cartlist", {cart:state.listitems.cart});
    },
    removeCartMultiple(state, itemlist){
      itemlist.forEach(function(val, index, array){
        let i = state.listitems.cart.indexOf(val.item_id);
        if (i > -1)
        state.listitems.cart.splice(i,1);
      });
      if(state.auth.loggedin && state.auth.role=="user")
        axios.post("/api/cartlist", {cart:state.listitems.cart});
    },
    amount(state, amount){
      state.amount = amount;
    }
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.MyPageAuth)) {
    if(store.state.auth.loggedin)
      next();
    else
      next({ path: '/login', query:{ next:"/mypage" } });
  } 
  else if (to.matched.some(record => record.name==="login")){
    if(store.state.auth.loggedin)
      next("/");
    else
      next();
  }

  else
    next()
});

new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app')